import { createSelector } from 'reselect';

const autoselectedFromPhoneSelector = (lastMessages, numbers, userId, query, defaultTrackedPhoneId, serviceProviderLocations, activeLeadPipelineLeads) =>
  createSelector(lastMessages, numbers, userId, query, defaultTrackedPhoneId, serviceProviderLocations, activeLeadPipelineLeads, (lastMessages, numbers, userId, query, defaultTrackedPhoneId, serviceProviderLocations, activeLeadPipelineLeads) => {
    const trackedPhones = numbers.filter((n) => n.platformCode !== 'whatconverts');
    const mostRecentMessage = (lastMessages || {})[
      {
        text: 'texts',
        call: 'calls',
      }[query.type]
    ];
    let mostRecentNumber;
    if (mostRecentMessage) {
      const key = query.type === 'call' ? 'tracking_number' : query.type === 'text' ? (mostRecentMessage.outgoing === '0' ? 'to_phone_number' : 'from_phone_number') : undefined;
      mostRecentNumber = trackedPhones.find((n) => n.phoneNumber === mostRecentMessage[key]);
    }
    const firstInstanceOfActivePipelineLead = (activeLeadPipelineLeads || []).find((n) => n.status_id === '1');
    let locationDefaultTrackedPhoneId = null;
    if (firstInstanceOfActivePipelineLead) {
      const locationOfPipelineLead = (serviceProviderLocations || []).find((n) => n.id === firstInstanceOfActivePipelineLead.service_location_id);
      locationDefaultTrackedPhoneId = locationOfPipelineLead && locationOfPipelineLead.default_tracked_phone_id ? locationOfPipelineLead.default_tracked_phone_id : null;
    }
    return mostRecentNumber || trackedPhones.find((n) => n.user_id === userId || n.userId === userId) || trackedPhones.find((n) => n.id === locationDefaultTrackedPhoneId) || trackedPhones[0];
  });

export default autoselectedFromPhoneSelector;
